import { useCallback } from 'react'
import { useSelector } from 'react-redux'

import {
  broadcastSessionTermination as sharedBroadcastSessionTermination,
  useSessionSync as useSharedSessionSync,
} from '@lyrahealth-inc/shared-app-logic'

import { sessionExpiredLogout, setIsSessionTimedOut } from '../../data/logout/logoutActions'
import { useAppDispatch } from '../../data/storeConfiguration/store'
import { getIsUserLoggedIn } from '../../data/user/userSelectors'

export const useSessionSync = () => {
  const appDispatch = useAppDispatch()
  const isLoggedIn = useSelector(getIsUserLoggedIn)
  const getIsLoggedIn = useCallback(() => isLoggedIn, [isLoggedIn])

  useSharedSessionSync({
    dispatch: appDispatch,
    getIsLoggedIn,
    sessionExpiredLogoutAction: sessionExpiredLogout,
    setIsSessionTimedOutAction: setIsSessionTimedOut,
  })
}

export const broadcastSessionTermination = (isSessionTimedOut = false) => {
  sharedBroadcastSessionTermination(isSessionTimedOut)
}
